import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router/index.js'
import Vant from 'vant';
import 'vant/lib/index.css';
 const app = createApp(App)
app.use(router).use(Vant).mount('#app')